import {Auction} from 'domain-models'
import _ from 'lodash'
import {AuctionFilter} from "redux/actions"

export type AuctionsState = {
  auction: Auction | null,
  auctions: Array<Auction>,
  current_page: number,
  filter: AuctionFilter,
  last_page: number,
  next_page_url: string | null,
  loading: boolean,
  hot_bid_auctions: Array<Auction>
  status: string | null
  total: number
}

type AuctionAction = {
  type: string
  auctions: Array<Auction>
  last_page: number
  current_page: number
  next_page_url: number | null
  filter: any
  loading: boolean
  auction: Auction | null
  total: number
  auctionId?: number
}
const initialState: AuctionsState = {
  auctions: [],
  current_page: 1,
  last_page: 1,
  filter: {
    type: null
  },
  next_page_url: null,
  auction: null,
  loading: false,
  hot_bid_auctions: [],
  status: null,
  total: 0
}

const auctionReducer = (state: AuctionsState = initialState, action: AuctionAction) => {
  switch (action.type) {
    case 'FETCH_AUCTIONS':
      return {
        ...state,
        auctions: action.auctions,
        last_page: action.last_page,
        current_page: action.current_page,
        next_page_url: action.next_page_url,
        filter: action.filter,
        total: action.total,
        loading: false
      }
    case 'APPEND_AUCTIONS':
      return {
        ...state,
        auctions: action.auctions,
        current_page: action.current_page,
        next_page_url: action.next_page_url,
        loading: false
      }
    case 'SET_AUCTIONS':
      return {
        ...state,
        auctions: action.auctions,
      }
    case 'SET_HOT_BID_AUCTION':
      return {
        ...state,
        hot_bid_auctions: [
          ...state.hot_bid_auctions,
          action.auction
        ],
      }
    case 'REMOVE_HOT_BID_AUCTION':
      return {
        ...state,
        hot_bid_auctions: _.without(state.hot_bid_auctions, action.auction)
      }
    case 'SET_AUCTION_FILTER':
      return {
        ...state,
        filter: action.filter,
      }
    case 'AUCTION_DETAILS':
      return {
        ...state,
        auction: action.auction,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.loading,
      }
    case 'SHOW_NEWLY_ARRIVED':
      return {
        ...state,
        auctions: action.auctions,
        filter: {
          type: null
        },
        loading: false,
        last_page: action.last_page,
        current_page: action.current_page,
        next_page_url: action.next_page_url,
      }
    case 'MARK_AUCTION_CANCELLED':
      // Mark the auction as cancelled if it's currently shown in the modal
      const updatedAuction = state.auction && state.auction.Id === action.auctionId
        ? {...state.auction, status: 'cancelled'}
        : state.auction
      return {
        ...state,
        auction: updatedAuction
      }
    default:
      return state
  }
}

export default auctionReducer
